import type { ServiceLabels } from '@/lib/form-state/util'

export const EVENT_STATUS_COLORS = {
    PENDING: {
        bg: 'bg-amber-100',
        border: 'border-amber-400',
        text: 'text-amber-800',
        dot: 'bg-amber-400',
    },
    CONFIRMED: {
        bg: 'bg-green-100',
        border: 'border-green-400',
        text: 'text-green-800',
        dot: 'bg-green-400',
    },
    CANCELED: {
        bg: 'bg-red-100',
        border: 'border-red-400',
        text: 'text-red-800',
        dot: 'bg-red-400',
    },
    COMPLETED: {
        bg: 'bg-blue-100',
        border: 'border-blue-400',
        text: 'text-blue-800',
        dot: 'bg-blue-400',
    },
    NO_SHOW: {
        bg: 'bg-gray-100',
        border: 'border-gray-400',
        text: 'text-gray-800',
        dot: 'bg-gray-400',
    },
    OVERDUE: {
        bg: 'bg-orange-100',
        border: 'border-orange-400',
        text: 'text-orange-800',
        dot: 'bg-orange-400',
    },
    NO_SHOW_JUSTIFIED: {
        bg: 'bg-purple-100',
        border: 'border-purple-400',
        text: 'text-purple-800',
        dot: 'bg-purple-400',
    },
    RESCHEDULED: {
        bg: 'bg-cyan-100',
        border: 'border-cyan-400',
        text: 'text-cyan-800',
        dot: 'bg-cyan-400',
    },
}

export const EVENT_STATUS_LABELS: Record<string, string> = {
    PENDING: 'Pendente',
    CONFIRMED: 'Confirmado',
    CANCELED: 'Cancelado',
    COMPLETED: 'Concluído',
    NO_SHOW: 'Não compareceu',
    OVERDUE: 'Atrasado',
    NO_SHOW_JUSTIFIED: 'Falta justificada',
    RESCHEDULED: 'Reagendado',
}

/** Tarefas de vendas: eventos TASK_* na agenda pessoal (docs/sales-tasks.md). */
export const TASK_TYPE_LABELS: Record<string, string> = {
    TASK_CALL: 'Ligar',
    TASK_FOLLOW_UP: 'Acompanhar',
    TASK_MEETING: 'Reunião',
    TASK_SEND_QUOTE: 'Enviar orçamento',
    TASK_OTHER: 'Outra tarefa',
}

export const isTaskType = (type?: string | null) => !!type && type.startsWith('TASK_')

/** Duração de uma tarefa sem término informado (a mesma do backend). */
export const TASK_DEFAULT_DURATION_MINUTES = 30

export const EVENT_TYPE_LABELS: Record<string, string> = {
    CONSULTATION: 'Consulta',
    RETURN: 'Retorno',
    EXAM: 'Exame',
    PROCEDURE: 'Procedimento',
    OTHER: 'Outro',
    ...TASK_TYPE_LABELS,
}

/**
 * `EVENT_TYPE_LABELS` no vocabulário do segmento (fora da saúde, Procedimento
 * vira Pedido e Consulta vira Avaliação). Use nas telas; a constante crua fica
 * como fallback para código sem acesso ao hook.
 */
export function getEventTypeLabels(
    labels: ServiceLabels
): Record<string, string> {
    return {
        CONSULTATION: labels.Consultation,
        RETURN: 'Retorno',
        EXAM: labels.Exam,
        PROCEDURE: labels.Order,
        OTHER: 'Outro',
        ...TASK_TYPE_LABELS,
    }
}

export const BLOCK_TYPE_COLORS = {
    VACATION: {
        bg: 'bg-indigo-100',
        border: 'border-indigo-400',
        text: 'text-indigo-800',
    },
    MEETING: {
        bg: 'bg-pink-100',
        border: 'border-pink-400',
        text: 'text-pink-800',
    },
    BREAK: {
        bg: 'bg-teal-100',
        border: 'border-teal-400',
        text: 'text-teal-800',
    },
    HOLIDAY: {
        bg: 'bg-rose-100',
        border: 'border-rose-400',
        text: 'text-rose-800',
    },
    PERSONAL: {
        bg: 'bg-violet-100',
        border: 'border-violet-400',
        text: 'text-violet-800',
    },
    OTHER: {
        bg: 'bg-slate-100',
        border: 'border-slate-400',
        text: 'text-slate-800',
    },
}

export const BLOCK_TYPE_LABELS: Record<string, string> = {
    VACATION: 'Ferias',
    MEETING: 'Reuniao',
    BREAK: 'Intervalo',
    HOLIDAY: 'Feriado',
    PERSONAL: 'Pessoal',
    OTHER: 'Outro',
}

export function getStatusColor(status: string) {
    return (
        EVENT_STATUS_COLORS[status as keyof typeof EVENT_STATUS_COLORS] ||
        EVENT_STATUS_COLORS.PENDING
    )
}

export function getBlockTypeColor(type: string) {
    return (
        BLOCK_TYPE_COLORS[type as keyof typeof BLOCK_TYPE_COLORS] ||
        BLOCK_TYPE_COLORS.OTHER
    )
}
